import { ApolloError, MutationFunction } from '@apollo/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExportContactQuery, ExportContactQueryVariables } from 'generated/graphql';

interface ContactExportResponse {
  success?: {
    vCard: string[];
  };
  error?: ApolloError | undefined;
}

interface ContactExportArg {
  payload: {
    ids: string[];
  };
  getContactExportHook: MutationFunction<ExportContactQuery, ExportContactQueryVariables>;
}

export const exportContactThunk = createAsyncThunk(
  'exportContact',
  async (arg: ContactExportArg): Promise<ContactExportResponse> => {
    try {
      const response = await arg.getContactExportHook({
        variables: arg.payload,
      });
      return {
        success: {
          vCard: response.data?.exportContact.vCard as string[],
        },
      };
    } catch (e) {
      return {
        error: e as ApolloError,
      };
    }
  }
);
